'use client'

import { useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/messaging/conversation-action-feature'
import { GenerateLabelModal } from '@marketplace-web/conversation-shipping/conversation-shipping-data'

import { clickEvent } from '_libs/common/event-tracker/events'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'

import DigitalLabelModal from '../DigitalLabelModal'
import DropOffPointModal from '../DropOffPointModal'

type Props = ConversationActionProps

const OpenQrCode = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { conversation } = useConversationContext()

  const [visibleModal, setVisibleModal] = useState<GenerateLabelModal>(GenerateLabelModal.None)

  const transactionId = conversation?.transaction?.id

  function trackButtonClick() {
    const targetDetails = { transaction_id: transactionId }

    track(
      clickEvent({
        screen: Screen.MessageReply,
        target: ClickableElement.OpenDigitalLabel,
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  function handleButtonClick() {
    trackButtonClick()
    setVisibleModal(GenerateLabelModal.OpenQrCodeModal)
  }

  function handleModalClose() {
    setVisibleModal(GenerateLabelModal.None)
  }

  function handleDropOffPointModalOpen() {
    setVisibleModal(GenerateLabelModal.DropOffPointMapModal)
  }

  function handleDropOffPointModalClose() {
    setVisibleModal(GenerateLabelModal.OpenQrCodeModal)
  }

  return (
    <>
      <ConversationActionButton
        primary={primary}
        text={title}
        size={size}
        inverse={inverse}
        theme={theme}
        onClick={handleButtonClick}
        testId="open-digital-label-button"
      />
      <DigitalLabelModal
        isOpen={visibleModal === GenerateLabelModal.OpenQrCodeModal}
        onClose={handleModalClose}
        onDropOffPointModalOpen={handleDropOffPointModalOpen}
      />
      <DropOffPointModal
        isOpen={visibleModal === GenerateLabelModal.DropOffPointMapModal}
        onClose={handleDropOffPointModalClose}
      />
    </>
  )
}

export default OpenQrCode
